import { EXTRAS_TABLE } from '../data/content';
import SectionHead from './SectionHead';
import { Reveal } from '../lib/motion';

const DISCOUNTS = [
  { months: '3 Monate', value: '−5\u202F%' },
  { months: '6 Monate', value: '−10\u202F%' },
  { months: '12 Monate', value: '−15\u202F%' },
];

export default function ExtrasSection() {
  return (
    <section id="extras" data-testid="extras-section" className="chapter bg-[#16181D]/40">
      <div className="wrap">
        <SectionHead
          n="06"
          eyebrow="Extras & Laufzeit"
          title="Zubuchen, was Sie brauchen. Länger buchen, weniger zahlen."
          testid="extras-headline"
          lead="Spotproduktion, Exklusivität, Zeitfenster oder Sponsoring – alles optional, alles transparent. Und je länger die Laufzeit, desto günstiger der Monat."
        />

        <div className="mt-16 grid gap-10 lg:grid-cols-12">
          <Reveal className="lg:col-span-8">
            <div className="divide-y divide-[#282C37] border-y border-[#282C37]" data-testid="extras-table">
              {EXTRAS_TABLE.map((e, i) => (
                <div key={e.name} className="grid gap-2 py-6 sm:grid-cols-12 sm:gap-6" data-testid={`extras-row-${i}`}>
                  <div className="sm:col-span-4">
                    <p className="font-display text-lg font-bold">{e.name}</p>
                  </div>
                  <p className="t-body sm:col-span-5">{e.what}</p>
                  <div className="sm:col-span-3 sm:text-right">
                    <p className="font-mono-num text-xl font-bold text-[#FF6B00]">{e.price}</p>
                    <p className="text-xs text-[#7D8391]">{e.unit}</p>
                  </div>
                </div>
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-4">
            <div className="rounded-2xl border border-[#FF6B00]/40 bg-[#16181D] p-7 sm:p-9" data-testid="discount-ladder">
              <p className="eyebrow">Laufzeit-Nachlass</p>
              <h3 className="mt-3 font-display text-2xl font-extrabold tracking-tight">Länger buchen, weniger zahlen.</h3>
              <div className="mt-7 divide-y divide-[#282C37]">
                {DISCOUNTS.map((d) => (
                  <div key={d.months} className="flex items-center justify-between py-4" data-testid={`discount-${d.months.replace(' ', '-')}`}>
                    <span className="text-base text-[#B6BCC8]">ab {d.months}</span>
                    <span className="font-mono-num text-3xl font-bold text-[#FF6B00]">{d.value}</span>
                  </div>
                ))}
              </div>
              <p className="t-muted mt-6">
                Gilt für die Monatspakete. Gründungspartner erhalten 20 % auf zwölf Monate. Alle Preise netto zuzüglich 19 % Umsatzsteuer.
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
